import { render } from "./HomePageLatestArticle.vue?vue&type=template&id=68245543&scoped=true"
import script from "./HomePageLatestArticle.vue?vue&type=script&lang=js"
export * from "./HomePageLatestArticle.vue?vue&type=script&lang=js"

import "./HomePageLatestArticle.vue?vue&type=style&index=0&id=68245543&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68245543"]])

export default __exports__